import PropTypes from 'prop-types';

import UploadedImageModel from './UploadedImage';

export default {
  images: PropTypes.arrayOf(PropTypes.shape(UploadedImageModel)),
  orientation: PropTypes.string.isRequired,
};
